import React from 'react';
import styles from './Button.module.scss';

const Button = ({ variant = 'primary', onClick, disabled, children }) => {
  const buttonClasses = `${styles.btn} ${styles[variant]}`;

  return (
    <button
        className={buttonClasses}
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </button>
  );
};

export default Button;
